import type { ReactNode } from 'react';

/**
 * Three or four tiles: a grid from `lg` up, a horizontal snap scroller below
 * it, the way the reference lays figures out on a phone.
 */
export const TileRow = ({ columns, children }: { columns: 3 | 4; children: ReactNode }) => (
  <div className="scrollbar-none -mx-6 snap-x snap-mandatory overflow-x-auto px-6 sm:-mx-8 sm:px-8 lg:mx-0 lg:overflow-visible lg:px-0">
    <div
      className={`flex gap-4 md:gap-6 lg:grid ${columns === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'} [&>figure]:w-80 [&>figure]:shrink-0 [&>figure]:snap-start lg:[&>figure]:w-auto`}
    >
      {children}
    </div>
  </div>
);
